import React, { useCallback } from 'react';
import InternalStatusIndicator from '../../../status-indicator/internal';
import { fireNonCancelableEvent } from '../../events';
import styles from './styles.css.js';
var DropdownStatus = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.root }, children);
};
export var useDropdownStatus = function (_a) {
    var statusType = _a.statusType, empty = _a.empty, loadingText = _a.loadingText, finishedText = _a.finishedText, errorText = _a.errorText, recoveryText = _a.recoveryText, isEmpty = _a.isEmpty, isNoMatch = _a.isNoMatch, noMatch = _a.noMatch, onRecoveryClick = _a.onRecoveryClick;
    var statusContent = null;
    var handleRecoveryClick = useCallback(function (e) {
        e.preventDefault();
        fireNonCancelableEvent(onRecoveryClick);
    }, [onRecoveryClick]);
    if (statusType === 'loading') {
        statusContent = React.createElement(InternalStatusIndicator, { type: 'loading' }, loadingText);
    }
    else if (statusType === 'error') {
        statusContent = (React.createElement(React.Fragment, null,
            React.createElement(InternalStatusIndicator, { type: 'error', __uxdgInverted: true }, errorText),
            ' ',
            recoveryText && (React.createElement("a", { role: "button", tabIndex: -1, className: styles.recovery, onClick: handleRecoveryClick }, recoveryText))));
    }
    else if (isEmpty && empty) {
        statusContent = empty;
    }
    else if (isNoMatch && noMatch) {
        statusContent = noMatch;
    }
    else if (statusType === 'finished' && finishedText) {
        statusContent = finishedText;
    }
    return statusContent;
};
export default DropdownStatus;
//# sourceMappingURL=index.js.map